import { Location } from '@angular/common';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ExposedReadUserDetailsRes } from 'app/interfaces/responses/Exposed/exposedReadUserDetailsRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { USER_ROLES } from 'common/constants/user-role.constants';

@Component({
    selector: 'app-settings-configs',
    templateUrl: './settings-configs.component.html',
    styleUrls: ['./settings-configs.component.scss'],
})
export class SettingsConfigsComponent implements OnInit {
    userDetails: ExposedReadUserDetailsRes = null;
    userRoles = USER_ROLES;
    loader: boolean;
    loaderMessage: string;

    selectedPanel: string = '';
    @Input() selectedPanelIndex: number = 0;

    constructor(
        public lsrauthService: LsrauthService,
        private location: Location
    ) {
        this.lsrauthService.userDetails.subscribe((userDetails) => (this.userDetails = userDetails));
        this.findCorrectTabBasedOnUrl();
    }

    ngOnInit(): void {
        this.findCorrectTabBasedOnUrl();
        this.initPanelBasedOnUrl();
    }

    ngOnDestroy(): void {
        this.selectedPanel = null;
    }

    //#region Panel

    // Makes sure back and forward works within tabs
    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
        window.location.href = event.srcElement.location.href;
    }

    findCorrectTabBasedOnUrl() {
        try {
            this.selectedPanel = window.location.href.split('/').pop();
        } catch {}
    }

    initPanelBasedOnUrl() {
        if (this.selectedPanel == 'gildi') {
            this.selectedPanelIndex = 1;
        } else {
            this.selectedPanel = 'adstod';
            this.selectedPanelIndex = 0;
        }
    }

    tabChanged(event: MatTabChangeEvent) {
        if (event.index == 0) {
            this.location.go('/vefstillingar/kerfisstillingar/adstod');
        } else if (event.index == 1) {
            this.location.go('/vefstillingar/kerfisstillingar/gildi');
        }
    }

    //#endregion
}
